export default function assertNumericValue(value: unknown): value is number {
  return typeof value === "number";
}
